export const weatherIcon = (icon: string) => {
  return `http://openweathermap.org/img/wn/${icon}@2x.png`;
};
